import { z } from "zod";

export const BlockGenerationTaskInputSchema = z.object({
  blockPath: z.string(),
  toneDefinitionId: z.string().uuid().optional(),
  additionalInstructions: z.string().max(2048).optional(),
  strategy: z.enum(["openai", "anthropic"]).default("anthropic").optional(),
});

export type BlockGenerationTaskInput = z.infer<
  typeof BlockGenerationTaskInputSchema
>;
